<template>
  <span class="check">{{ props.text }}</span>
</template>

<script setup lang="ts">
interface Props {
  text: string;
}

const props = defineProps<Props>();
</script>

<style scoped>
.check {
  color: #0f7931;
}

.check::before {
  content: '';
  display: inline-block;
  width: 16px;
  height: 18px;
  padding-left: 16px;
  background-image: url('@/assets/img/check-green.svg');
  background-repeat: no-repeat;
  background-size: contain;
  vertical-align: middle;
  margin-right: 4px;
  margin-bottom: 2px;
}
</style>
